import React, {useRef} from "react"
import { useNavigate } from "react-router-dom"
import DataTable from "../components/table/dataTable"
import { getTokenExpired, hasRoles } from "../components/utils"
import PageLayout from "../components/layouts/pageLayout"
import Button from "../components/ui/button"

const SessionsPage = () => {
  const navigate = useNavigate()
  const tableRef = useRef(null);

  if (getTokenExpired()) return navigate("/login")

  const tableId = hasRoles("Admin") ? 5 : 4;

  const onCreateSession = async () => {
    if (tableRef.current) {
        await tableRef.current.openModal("createSession", []);
    }
  }

return (
    <PageLayout title="Logs">
      <DataTable tableId={tableId} ref={tableRef} actionButton={<Button variant="contained" onClick={onCreateSession}> + New Log</Button>} hideView />
    </PageLayout>
  )
}

export default SessionsPage
